<div class="container h-100">
  <div *ngIf="profileService.isLoading" class="row h-100 justify-content-center align-items-center">
    <div class="text-center">
      <app-loading-spinner></app-loading-spinner>
    </div>
  </div>
  <div class="row justify-content-center align-items-center VerticalMargin mb-5" *ngIf="!profileService.isLoading">
    <div class="card RegularForm rounded col-12">
      <div class="card-body MyCardBody rounded-bottom">
        <p class="required-fields-note">{{ ('FIELDS_MARKED_ARE_REQUIRED' | translate) }}</p>
        <section *ngIf="householdEditor" #householdSummary tabindex="-1" class="mb-4" style="scroll-margin-top:85px">
              <p *ngIf="householdConfirmation" class="alert alert-success" role="status">{{ householdConfirmation }}</p>
          <h2>{{ isAdmin === 'true' ? ('ACCOUNT_DETAILS_HOUSEHOLD' | translate) : ('MY_PROFILE_HOUSEHOLD' | translate) }}</h2>
          <p *ngIf="householdSetup">{{ 'WELCOME_YOUR_ACCOUNT_IS_SAVED_ADD_YOUR_HOUSEHOLD_MEMBERS_NOW_OR_CONTINUE' | translate }}</p><p>{{ 'CHOOSE_WHOSE_INFORMATION_TO_EDIT_OR_ADD_A_HOUSEHOLD_MEMBER' | translate }}</p>
          <div *ngFor="let person of memberArr" class="household-person d-flex align-items-center justify-content-between py-3 border-bottom">
            <div *ngIf="person.id != 0" class="household-person-info"><img *ngIf="person.pictureUrl" [src]="person.pictureUrl" alt="" width="40" height="40" class="rounded-circle mr-2" style="object-fit: cover"><div><strong>{{ person.firstName }} {{ person.lastName }}</strong><small class="d-block">{{ householdRole(person) }}</small></div></div>
            <button *ngIf="person.id != 0" class="btn btn-outline-secondary" type="button" [disabled]="memberSaving || profileSaving || dupeBusy || memberDeleting || addingHouseholdMember || changingHouseholdEdit || continuingToApp" [attr.aria-busy]="changingHouseholdEdit && householdEditBusyId === person.id" [attr.aria-expanded]="isHouseholdPersonEditing(person)" (click)="editHouseholdPerson(person)"><i *ngIf="changingHouseholdEdit && householdEditBusyId === person.id" class="fas fa-spinner fa-spin profile-edit-spinner" aria-hidden="true"></i>{{ isHouseholdPersonEditing(person) ? ('CANCEL_EDITING' | translate) : ('EDIT' | translate) }}</button>
          </div>
        </section>
        <section *ngIf="householdEditor && (householdDupes.length || dupeError)" class="mb-4" [attr.aria-label]="'HOUSEHOLD_DUPLICATE_REVIEW' | translate">
          <h3>{{ 'POSSIBLE_DUPLICATE_HOUSEHOLD_MEMBERS' | translate }}</h3>
          <p>{{ 'THESE_RECORDS_MAY_DESCRIBE_THE_SAME_PERSON_REVIEW_THEM_NOW_OR_CONTINUE_A' | translate }}</p>
          <p *ngIf="dupeError" class="alert alert-warning" role="alert">{{ dupeError }}</p>
          <div *ngFor="let pair of householdDupes" class="border rounded p-3 mb-2">
            <p>{{ pair.member1.firstName }} {{ pair.member1.lastName }} &mdash; {{ pair.member1.dateOfBirth ? (pair.member1.dateOfBirth | localizedDate:'mediumDate') : ('DATE_OF_BIRTH_NOT_PROVIDED' | translate) }}</p>
            <p>{{ pair.member2.firstName }} {{ pair.member2.lastName }} &mdash; {{ pair.member2.dateOfBirth ? (pair.member2.dateOfBirth | localizedDate:'mediumDate') : ('DATE_OF_BIRTH_NOT_PROVIDED' | translate) }}</p>
            <div class="d-flex flex-wrap" style="gap:.5rem">
              <button type="button" class="btn btn-primary" [disabled]="dupeBusy || memberSaving || profileSaving || editingPrimary || editingHouseholdMemberId !== null" (click)="reviewHouseholdDupe(pair, false)"><i *ngIf="dupeBusy" class="fas fa-spinner fa-spin" aria-hidden="true"></i> {{ 'SAME_PERSON_COMBINE_RECORDS' | translate }}</button>
              <button type="button" class="btn btn-outline-primary" [disabled]="dupeBusy" (click)="reviewHouseholdDupe(pair, true)">{{ 'DIFFERENT_PEOPLE' | translate }}</button>
              <button type="button" class="btn btn-outline-secondary" [disabled]="dupeBusy" (click)="deferHouseholdDupe(pair)">{{ 'REVIEW_LATER' | translate }}</button>
            </div>
          </div>
        </section>
        <form *ngIf="profileForm && showAccountHolder == 'true'" [hidden]="householdEditor && !editingPrimary" [attr.inert]="changingHouseholdEdit ? '' : null" [formGroup]="profileForm" (ngSubmit)="onSubmit()"
          name="dummy" [class.SmallArabicFont]="globalService.isRTL == true">
          <h5 class="mb-4 formSectionHeader" [class.text-right]="globalService.isRTL == true"
            *ngIf="accountActivated == false">
            {{ globalService.Get("ACCOUNT_HOLDER") }}
            <small class="text-danger">
              {{ globalService.Get("NOT_ACTIVATED") }}
            </small>
            <div *ngIf="activationSent == false" class="mt-2">
              <button type="button" class="btn btn-primary btn-small" (click)="resendActivationEmail()">
                <span>
                  <i *ngIf="sendingActivation == true" class="fas fa-spinner fa-spin"></i>
                  {{ globalService.Get("RESEND_ACTIVATION_EMAIL") }}
                </span>
              </button>
            </div>
            <div *ngIf="activationSent == true" class="mt-2">
              <app-prompt-message [showForm]="activationSent == true && closeActivationSent == false" color="primary"
                (onClose)="closeActivationSent = true" [message]='globalService.Get("ACTIVATION_EMAIL_SENT")'>
              </app-prompt-message>
            </div>
          </h5>
          <h5 class="mb-4 formSectionHeader" [class.text-right]="globalService.isRTL == true"
            *ngIf="accountActivated == true">
            {{ globalService.Get("ACCOUNT_HOLDER") }}
          </h5>
          <div class="row">
            <div class="col-12 order-2 order-lg-1 col-lg-9">
              <div class="row">
                <div [hidden]="fieldHidden('email')" class="form-group col-12" [class.text-right]="globalService.isRTL == true">
                  <app-email-verification-reminder [profileMode]="true" [profileUserId]="userId" [refreshKey]="emailStatusVersion"></app-email-verification-reminder>
                  <label for="email">{{ globalService.Get("EMAIL") }} <span *ngIf="fieldRequired('email')" class="required-marker" [attr.aria-label]="'REQUIRED' | translate">*</span></label>
                  <input type="email" id="email" class="form-control" formControlName="email" />
                </div>
              </div>
              <div class="row">
                <div class="form-group col-6" [class.text-right]="globalService.isRTL == true">
                  <label for="firstName">{{
                    globalService.Get("FIRSTNAME")
                    }} <span class="required-marker" [attr.aria-label]="'REQUIRED' | translate">*</span></label>
                  <input type="text" id="firstName" class="form-control" formControlName="firstName"
                    autocomplete="new-firstName" />

                  <small class="help-block" *ngIf="
                      !profileForm.get('firstName').valid &&
                      (profileForm.get('firstName').touched || submit)
                    ">{{ globalService.Get("FIRSTNAME_REQUIRED") }}</small>
                </div>
                <div class="form-group col-6" [class.text-right]="globalService.isRTL == true">
                  <label for="lastName">{{
                    globalService.Get("LASTNAME")
                    }} <span class="required-marker" [attr.aria-label]="'REQUIRED' | translate">*</span></label>
                  <input type="text" id="lastName" class="form-control" formControlName="lastName"
                    autocomplete="new-lastName" />
                  <small class="help-block" *ngIf="
                      !profileForm.get('lastName').valid &&
                      (profileForm.get('lastName').touched || submit)
                    ">{{ globalService.Get("LASTNAME_REQUIRED") }}</small>
                </div>
              </div>
              <div class="row">
                <div [hidden]="fieldHidden('street')" class="form-group col-12" [class.text-right]="globalService.isRTL == true">
                  <app-address-autocomplete *ngIf="!householdEditor || editingPrimary" [form]="profileForm"></app-address-autocomplete>
                  <label for="street">{{ globalService.Get("STREET") }} <span *ngIf="fieldRequired('street')" class="required-marker" [attr.aria-label]="'REQUIRED' | translate">*</span></label>
                  <input type="text" id="street" #addressStreet class="form-control" formControlName="street"
                    autocomplete="new-street" />
                  <small class="help-block" *ngIf="
                      !profileForm.get('street').valid &&
                      (profileForm.get('street').touched || submit)
                    ">{{ globalService.Get("STREET_REQUIRED") }}</small>
                </div>
              </div>
            </div>
            <div [hidden]="fieldHidden('picture')" class="col-12 order-1 order-lg-2 col-lg-3 mt-4" [class.text-right]="globalService.isRTL == true">
              <div class="form-group text-center">

                <!-- Image -->
                <div>
                  <a [href]="pictureUrl" target="_blank" rel="noopener noreferrer">
                    <img [src]="pictureUrl" class="profileImage mb-2 d-block mx-auto" style="cursor: pointer;" />
                  </a>
                </div>

                <!-- Buttons -->
                <div class="mt-2" *ngIf="allowEdit == true">
                  <label for="profilePic" class="btn btn-primary btn-small mr-2">
                    {{ globalService.Get("SELECT") }}
                  </label>

                  <label class="btn btn-danger btn-small" (click)="resetPicture(0)">
                    {{ globalService.Get("CLEAR") }}
                  </label>
                </div>

                <!-- Hidden input -->
                <input hidden type="file" accept="image/*" id="profilePic"
                  (change)="onFileSelectedPrimary($event, 0)" />

              </div>
            </div>
          </div>
          <div class="row">
            <div [hidden]="fieldHidden('city')" class="form-group col-6 col-lg-3" [class.text-right]="globalService.isRTL == true">
              <label for="city">{{ globalService.Get("CITY") }} <span *ngIf="fieldRequired('city')" class="required-marker" [attr.aria-label]="'REQUIRED' | translate">*</span></label>
              <input type="text" id="city" class="form-control" formControlName="city" autocomplete="new-city" />
              <small class="help-block" *ngIf="
                  !profileForm.get('city').valid &&
                  (profileForm.get('city').touched || submit)
                ">{{ globalService.Get("CITY_REQUIRED") }}</small>
            </div>
            <div [hidden]="fieldHidden('state')" class="form-group col-6 col-lg-3" [class.text-right]="globalService.isRTL == true">
              <label for="state">{{ globalService.Get("STATE") }} <span *ngIf="fieldRequired('state')" class="required-marker" [attr.aria-label]="'REQUIRED' | translate">*</span></label>
              <input type="state" id="state" class="form-control" formControlName="state" autocomplete="new-state" />
              <small class="help-block" *ngIf="
                  !profileForm.get('state').valid &&
                  (profileForm.get('state').touched || submit)
                ">{{ globalService.Get("STATE_REQUIRED") }}</small>
            </div>
            <div [hidden]="fieldHidden('zip')" class="form-group col-6 col-lg-3" [class.text-right]="globalService.isRTL == true">
              <label for="zip">{{ globalService.Get("ZIP") }} <span *ngIf="fieldRequired('zip')" class="required-marker" [attr.aria-label]="'REQUIRED' | translate">*</span></label>
              <input type="zip" id="zip" class="form-control" formControlName="zip" autocomplete="new-zip" />
              <small class="help-block" *ngIf="
                  !profileForm.get('zip').valid &&
                  (profileForm.get('zip').touched || submit)
                ">{{ globalService.Get("ZIP_REQUIRED") }}</small>
            </div>
            <div [hidden]="fieldHidden('gender')" class="form-group col-6 col-lg-3" [class.text-right]="globalService.isRTL == true">
              <label for="gender">{{ globalService.Get("GENDER") }} <span *ngIf="fieldRequired('gender')" class="required-marker" [attr.aria-label]="'REQUIRED' | translate">*</span></label>
              <select id="gender" class="form-control" [class.classicRTL]="globalService.isRTL == true"
                [class.classic]="globalService.isRTL == false" formControlName="gender">
                <option [ngValue]="null" [disabled]="fieldRequired('gender')">
                  {{ globalService.Get("SELECT") }}
                </option>
                <option [ngValue]="false">
                  {{ globalService.Get("MALE") }}
                </option>
                <option [ngValue]="true">
                  {{ globalService.Get("FEMALE") }}
                </option>
              </select>
              <small class="help-block" *ngIf="
                  !profileForm.get('gender').valid &&
                  (profileForm.get('gender').touched || submit)
                ">{{ globalService.Get("GENDER_REQUIRED") }}</small>
            </div>
            <div [hidden]="fieldHidden('country')" class="form-group col-12 col-lg-6" [class.text-right]="globalService.isRTL == true">
              <label for="country">{{ globalService.Get("COUNTRY") }} <span *ngIf="fieldRequired('country')" class="required-marker" [attr.aria-label]="'REQUIRED' | translate">*</span></label>
              <select id="country" class="form-control" [class.classicRTL]="globalService.isRTL == true"
                [class.classic]="globalService.isRTL == false" formControlName="country" (change)="OnCountryChange()">
                <option [ngValue]="null" *ngIf="!fieldRequired('country')">{{ 'SELECT' | translate }}</option>
                <option *ngFor="let country of countriesArr" [ngValue]="country.code">
                  {{ country.name }}
                </option>
              </select>
            </div>
            <div class="form-group col-12 col-lg-3" [class.text-right]="globalService.isRTL == true"
              *ngIf="shortDate == false && !fieldHidden('dateOfBirth')">
              <div class="dob-label">
                <label for="dateOfBirth">{{ globalService.Get("DOB") }} <span *ngIf="fieldRequired('dateOfBirth')" class="required-marker" [attr.aria-label]="'REQUIRED' | translate">*</span></label>
                <button type="button" class="btn btn-link dob-clear"
                  *ngIf="!fieldRequired('dateOfBirth') && profileForm.get('dateOfBirth').enabled && profileForm.get('dateOfBirth').value"
                  [disabled]="profileSaving || memberSaving || changingHouseholdEdit"
                  [attr.aria-label]="('CLEAR' | translate) + ' ' + ('DOB' | translate)"
                  (click)="clearDateOfBirth(profileForm.get('dateOfBirth'), primaryDateOfBirth)">{{ 'CLEAR' | translate }}</button>
              </div>
              <div>
                <div class="input-group dob-field">
                  <input id="dateOfBirth" formControlName="dateOfBirth" class="form-control" matInput
                    #primaryDateOfBirth
                    [matDatepicker]="dateOfBirth" [placeholder]="'MM_DD_YYYY' | translate" [required]="fieldRequired('dateOfBirth')"
                    (click)="globalService.OpenCalendar(dateOfBirth)" />
                  <mat-datepicker [touchUi]="
                      (globalService.isHandset$ | async) ? 'true' : 'false'
                    " #dateOfBirth></mat-datepicker>
                  <div class="input-group-append">
                    <button type="button" class="btn btn-secondary btn-small input-group-text"
                      [attr.aria-label]="'DOB' | translate"
                      (click)="globalService.OpenCalendar(dateOfBirth)">
                      <span>
                        <i class="fas fa-calendar-alt"></i>
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group col-12 col-lg-3" [class.text-right]="globalService.isRTL == true"
              *ngIf="shortDate == true && !fieldHidden('dateOfBirth')">
              <label for="dateOfBirth">{{ globalService.Get("DOB") }} <span *ngIf="fieldRequired('dateOfBirth')" class="required-marker" [attr.aria-label]="'REQUIRED' | translate">*</span></label>
              <div>
                <div class="input-group">
                  <input class="form-control" disabled="true" [value]="GetPrimaryShortDate()" />
                </div>
              </div>
            </div>
            <div [hidden]="fieldHidden('maritalStatus')" class="form-group col-12 col-lg-3" [class.text-right]="globalService.isRTL == true">
              <label for="maritalStatus">{{
                globalService.Get("MARITAL_STATUS")
                }} <span *ngIf="fieldRequired('maritalStatus')" class="required-marker" [attr.aria-label]="'REQUIRED' | translate">*</span></label>
              <select id="maritalStatus" class="form-control" [class.classicRTL]="globalService.isRTL == true"
                [class.classic]="globalService.isRTL == false" formControlName="maritalStatus">
                <option [ngValue]="null">
                  {{ globalService.Get("SELECT") }}
                </option>
                <option [ngValue]="0">{{ globalService.Get("SINGLE") }}</option>
                <option [ngValue]="1">
                  {{ globalService.Get("ENGAGED") }}
                </option>
                <option [ngValue]="2">
                  {{ globalService.Get("MARRIED") }}
                </option>
                <option [ngValue]="3">
                  {{ globalService.Get("WIDOWED") }}
                </option>
                <option [ngValue]="4">
                  {{ globalService.Get("DIVORCED") }}
                </option>
                <option [ngValue]="5">
                  {{ globalService.Get("DEPARTED") }}
                </option>
              </select>
              <small class="help-block" *ngIf="
                  !profileForm.get('maritalStatus').valid &&
                  (profileForm.get('maritalStatus').touched || submit)
                ">{{ globalService.Get("MARITAL_STATUS_REQUIRED") }}</small>
            </div>
            <div class="form-group col-12 col-lg-9" [class.text-right]="globalService.isRTL == true">
              <label for="isMember" (click)="MemberStatusHelp()">{{ globalService.Get("MEMBERSHIP")
                }}<i class="fas fa-question-circle" [class.ml-2]="globalService.isRTL == false"
                  [class.mr-2]="globalService.isRTL == true"></i> <span class="required-marker" [attr.aria-label]="'REQUIRED' | translate">*</span></label>
              <app-user-message *ngIf="showMemberStatusTip == true" style="margin-top: 0px" [type]="'secondary'" class="mt-2"
                (close)="showMemberStatusTip = false">
                {{ globalService.Get("MEMBER_DEFINITION") }} <br />
                {{ globalService.Get("GUEST_DEFINITION") }}
              </app-user-message>
              <div>
                <select id="isMember" class="form-control" [class.classicRTL]="globalService.isRTL == true"
                  [class.classic]="globalService.isRTL == false" formControlName="isMember">
                  <!-- <option [ngValue]="null">Select</option> -->
                  <option [ngValue]="1">
                    {{ globalService.Get("MEMBER") }}
                  </option>
                  <option [ngValue]="2">
                    {{ globalService.Get("GUEST") }}
                  </option>
                </select>
              </div>

              <div class="input-group mt-2" *ngIf="
                  memberArr != null &&
                  memberArr.length > 0 &&
                  memberArr[0].requestDescription != '' &&
                  workflow == true
                ">
                <div [class.input-group-prepend]="adminAccess == true" *ngIf="adminAccess == false">
                  <span class="input-group-text" id="basic-addon1">
                    {{
                    globalService.Get(
                    memberArr[0].requestDescription.split(
                    "
                    "
                    )[0]
                    )
                    }}
                  </span>
                </div>
                <div [class.input-group-prepend]="adminAccess == true" *ngIf="adminAccess == true">
                  <span class="input-group-text" id="basic-addon1">
                    {{
                    globalService.Get(
                    memberArr[0].requestDescription.split(
                    "
                    "
                    )[0]
                    ) +
                    " " +
                    globalService.Get(
                    memberArr[0].requestDescription
                    .split(" ")[1]
                    .trim()
                    .toUpperCase()
                    ) +
                    " " +
                    memberArr[0].requestDescription.split(" ")[2]
                    }}
                  </span>
                </div>
                <div class="input-group-append" *ngIf="adminAccess == true">
                  <button type="button" (click)="AcceptRequest(memberArr[0].id, 0)" class="btn btn-success btn-small">
                    <span>
                      <i class="fas fa-check-circle mr-1"></i><small>{{ globalService.Get("APPROVE") }}</small>
                    </span>
                  </button>
                </div>
                <div class="input-group-append" *ngIf="adminAccess == true">
                  <button type="button" (click)="DenyRequest(memberArr[0].id, 0)" class="btn btn-danger btn-small">
                    <span>
                      <i class="fas fa-times-circle mr-1"></i><small>{{ globalService.Get("DENY") }}</small></span>
                  </button>
                </div>
              </div>
            </div>
            <div [hidden]="fieldHidden('occupation')" class="form-group col-12" [class.text-right]="globalService.isRTL == true">
              <label for="occupation">{{ globalService.Get("OCCUPATION") }} <span *ngIf="fieldRequired('occupation')" class="required-marker" [attr.aria-label]="'REQUIRED' | translate">*</span></label>
              <div>
                <select id="occupation" class="form-control" [class.classicRTL]="globalService.isRTL == true"
                  [class.classic]="globalService.isRTL == false" formControlName="occupation">
                  <option [ngValue]="null">
                    {{ globalService.Get("SELECT") }}
                  </option>
                  <option *ngFor="let occupation of occupations" [ngValue]="occupation.id">
                    {{ occupation.name }}
                  </option>
                </select>

              </div>
            </div>
            <div class="form-group col-12" [class.text-right]="globalService.isRTL == true">
              <label *ngIf="emailVerification" for="profile-phone">{{ 'PHONE_NUMBER_306F1BB' | translate }}</label><input *ngIf="emailVerification" id="profile-phone" class="form-control" type="tel" inputmode="numeric" [(ngModel)]="phoneNumber" [ngModelOptions]="{standalone:true}" dir="ltr"><small *ngIf="emailVerification">{{ 'THIS_CHURCH_USES_EMAIL_VERIFICATION_NO_TEXT_MESSAGE_IS_REQUIRED' | translate }}</small>
              <app-phone-verify *ngIf="!emailVerification" [authenticateOnVerify]="false" [dial_code]="dial_code" [enabled]="true" [phone_number]="phoneNumber"
                (failed)="failedVerification()" (clearEvent)="clearCellPhone()" [phoneConfirmed]="phoneConfirmed"
                (verificationProof)="phoneVerificationToken = $event" (confirmNumber)="ConfirmCellPhone($event)"></app-phone-verify>
            </div>
          </div>
          <div [class.text-right]="globalService.isRTL == true">
            <label for="gender">{{ globalService.Get("PREFERED_LANGUAGE") }} <span *ngIf="fieldRequired('language')" class="required-marker" [attr.aria-label]="'REQUIRED' | translate">*</span></label>
            <select id="language" class="form-control language-name-select" [class.classicRTL]="globalService.isRTL == true"
              [class.classic]="globalService.isRTL == false" formControlName="language">
              <option [ngValue]="null" *ngIf="!fieldRequired('language')">{{ 'SELECT' | translate }}</option>
              <option [ngValue]="language" *ngFor="let language of languages">
                {{ globalService.languageOptionLabel(language) }}
              </option>
            </select>
          </div>

          <div formArrayName="extensions" class="row mt-3">
            <div *ngFor="let extension of extensions.controls; let i = index" class="form-group col-12 col-md-6">
              <div [formGroupName]="i">
                <label> {{ extension.get("label").value }} <span *ngIf="extension.get('mandatory')?.value" class="required-marker" [attr.aria-label]="'REQUIRED' | translate">*</span></label>
                <div *ngIf="extension.get('options').value == null">
                  <input type="text" class="form-control" formControlName="value" />
                  <small class="help-block" *ngIf="
                  !extension.get('value').valid &&
                  (extension.get('value').touched || submit)
                ">{{ 'VALUE0_REQUIRED' | translate:{value0:(extension.get("label").value)} }}</small>
                </div>
                <div *ngIf="extension.get('options').value != null">
                  <select class="form-control" [class.classicRTL]="globalService.isRTL == true" formControlName="value"
                    [class.classic]="globalService.isRTL == false">
                    <option [ngValue]="null" disabled>{{ globalService.Get("SELECT") }}</option>
                    <option *ngFor="let option of extension.get('options').value" [ngValue]="option">
                      {{ option }}
                    </option>
                  </select>
                  <small class="help-block" *ngIf="
                  !extension.get('value').valid &&
                  (extension.get('value').touched || submit)
                ">{{ 'VALUE0_REQUIRED' | translate:{value0:(extension.get("label").value)} }}</small>
                </div>
              </div>
            </div>
          </div>

          <div class="row"><div class="form-group col-12"><label class="communication-switch" for="primary-receive-Text"><span>{{ 'RECEIVE_TEXT_MESSAGES' | translate }}</span><input id="primary-receive-Text" type="checkbox" role="switch" [checked]="!profileForm.get('disableText').value" (change)="setPrimaryCommunication('disableText', $event.target.checked)" /><span class="switch-track" aria-hidden="true"></span></label></div>
<div class="form-group col-12"><label class="communication-switch" for="primary-receive-Email"><span>{{ 'RECEIVE_EMAILS' | translate }}</span><input id="primary-receive-Email" type="checkbox" role="switch" [checked]="!profileForm.get('disableEmail').value" (change)="setPrimaryCommunication('disableEmail', $event.target.checked)" /><span class="switch-track" aria-hidden="true"></span></label></div></div>

          <div class="form-group col-12" *ngIf="isAdmin == 'true'">
            <small *ngIf="profileForm.get('createdBy').value != null && profileForm.get('createdBy').value != ''"><input
                type="text" id="createdBy" class="form-control" style="width: 100%;"
                formControlName="createdBy" /></small>
            <small><input type="text" id="creationDate" class="form-control" style="width: 100%;"
                [value]="profileForm.get('creationDate').value | localizedDate: 'MM/dd/yyyy'" /></small>
          </div>

          <app-prompt-message [showForm]="isSuccess == true && successClosed == false" color="success"
            (onClose)="successClosed = true" [message]="GetProfileSuccess()">
          </app-prompt-message>
          <app-prompt-message [showForm]="!failureClosed && (error != '')" color="danger"
            (onClose)="failureClosed = true" [message]="globalService.Get(error) || error">
          </app-prompt-message>
          <app-prompt-message [showForm]="activationNeeded == true" color="warning" (onClose)="activationNeeded = false"
            [message]="'PLEASE_CHECK_YOUR_INBOX_FOR_AN_ACCOUNT_ACTIVATION_EMAIL' | translate">
          </app-prompt-message>
          <app-confirm-message [showForm]="confirmUnsubscribe == true" (onConfirm)="ExecuteUnsubscribe()" color="danger"
            (onCancel)="confirmUnsubscribe = false" [message]="globalService.Get('CONFIRM_UNSUBSCRIBE')">
          </app-confirm-message>

          <div class="form-group row">
            <div class="text-center col-12" *ngIf="!profileForm.valid && submit">
              <div class="alert alert-danger" role="alert">
                <small>{{ 'CHECK_REQUIRED_FIELDS' | translate }}</small>
              </div>
            </div>
          </div>


          <div class="row" *ngIf="allowEdit == true">
            <div class="form-group col-12" [class.col-md-6]="!householdEditor && userId === globalService.currentUserId">
              <button class="btn btn-primary btn-block" type="submit"
                [disabled]="!profileForm.dirty || profileSaving || addressAutocomplete?.selecting">
                <div *ngIf="!profileSaving">
                  <span>
                    <i class="fas fa-save"></i>
                    {{ globalService.Get("UPDATE_PROFILE") }}
                  </span>
                </div>
                <div *ngIf="profileSaving">
                  <span>
                    <i class="fas fa-spinner fa-spin"></i>
                    {{ globalService.Get("UPDATE_PROFILE") }}
                  </span>
                </div>
              </button>
            </div>
            <div class="form-group col-12 col-md-6" *ngIf="!householdEditor && userId === globalService.currentUserId">
              <button class="btn btn-danger btn-block" type="button" (click)="openAccountDeletion()">
                <div *ngIf="!profileUnsubscribe">
                  <span>
                    <i class="fas fa-trash"></i>
                    {{ 'DELETE_ACCOUNT_A2E20A3' | translate }}</span>
                </div>
                <div *ngIf="profileUnsubscribe">
                  <span>
                    <i class="fas fa-spinner fa-spin"></i>
                    {{ 'DELETE_ACCOUNT_A2E20A3' | translate }}</span>
                </div>
              </button>
            </div>
          </div>

          <button *ngIf="householdEditor" type="button" class="btn btn-outline-secondary btn-block mb-3" [disabled]="profileSaving || changingHouseholdEdit" [attr.aria-busy]="changingHouseholdEdit" (click)="requestCancelHouseholdEdit()"><i *ngIf="changingHouseholdEdit" class="fas fa-spinner fa-spin profile-edit-spinner" aria-hidden="true"></i>{{ 'CANCEL_EDITING' | translate }}</button>
          <ng-container *ngIf="householdEditor && editingPrimary && !continueAfterDiscard"><ng-container *ngTemplateOutlet="discardEditPrompt"></ng-container></ng-container>
        </form>
        <br>
        <h5 class="mb-4 formSectionHeader" *ngIf="!householdEditor && showMembers == 'true' && memberArr.length > 1"
          [class.text-right]="globalService.isRTL == true" [class.SmallArabicFont]="globalService.isRTL == true">
          {{ globalService.Get("HOUSEHOLD_MEMBERS") }}
        </h5>
        <div *ngIf="showMembers == 'true'">
          <div *ngFor="let member of memberArr; let indexOfMember = index"
            [class.text-right]="globalService.isRTL == true" [class.SmallArabicFont]="globalService.isRTL == true">
            <!-- <hr /> -->
            <form #memberForm="ngForm" [attr.inert]="changingHouseholdEdit ? '' : null" [hidden]="householdEditor && (member.isPrimary || (member.id != 0 && editingHouseholdMemberId !== member.id))" (ngSubmit)="onSubmitMember(memberForm, indexOfMember)">
              <input type="hidden" id="id" class="form-control" name="id" required #id="ngModel"
                [(ngModel)]="member.id" />
              <div class="row" *ngIf="member.isPrimary == false">
                <div class="col-12 order-2 order-lg-1" [class.col-lg-12]="member.isPrimary == true"
                  [class.col-lg-9]="member.isPrimary == false">
                  <div class="row">
                    <div class="form-group col-6 col-lg-3">
                      <label for="firstName">{{
                        globalService.Get("FIRSTNAME")
                        }} <span class="required-marker" [attr.aria-label]="'REQUIRED' | translate">*</span></label>
                      <input type="text" id="firstName" class="form-control" name="firstName" required
                        [disabled]="member.hasAccount" #firstName="ngModel" [(ngModel)]="member.firstName"
                        autocomplete="off" />
                      <small class="help-block"
                        *ngIf="!firstName.valid && (firstName.touched || submitMember) && (indexOfMember == curIndex)">{{
                        globalService.Get("FIRSTNAME_REQUIRED") }}</small>
                    </div>
                    <div class="form-group col-6 col-lg-3">
                      <label for="lastName">{{
                        globalService.Get("LASTNAME")
                        }} <span class="required-marker" [attr.aria-label]="'REQUIRED' | translate">*</span></label>
                      <input type="text" id="lastName" class="form-control" name="lastName" required
                        [disabled]="member.hasAccount" #lastName="ngModel" [(ngModel)]="member.lastName"
                        autocomplete="off" />
                      <small class="help-block"
                        *ngIf="!lastName.valid && (lastName.touched || submitMember) && (indexOfMember == curIndex)">{{
                        globalService.Get("LASTNAME_REQUIRED") }}</small>
                    </div>

                    <div class="form-group col-12 col-lg-6" *ngIf="shortDate == false && !fieldHidden('dateOfBirth')">
                      <div class="dob-label"><label for="dateOfBirth">{{
                        globalService.Get("DOB")
                        }} <span *ngIf="fieldRequired('dateOfBirth')" class="required-marker" [attr.aria-label]="'REQUIRED' | translate">*</span></label>
                        <button type="button" class="btn btn-link dob-clear"
                          *ngIf="!fieldRequired('dateOfBirth') && !member.hasAccount && memberDateOfBirth.value"
                          [disabled]="profileSaving || memberSaving || changingHouseholdEdit"
                          [attr.aria-label]="('CLEAR' | translate) + ' ' + ('DOB' | translate)"
                          (click)="clearDateOfBirth(memberDateOfBirth.control, dateOfBirthInput)">{{ 'CLEAR' | translate }}</button>
                      </div>
                      <div>
                        <div class="input-group dob-field">
                          <input id="dateOfBirth" name="dateOfBirth" class="form-control" matInput
                            [disabled]="member.hasAccount" [matDatepicker]="dateOfBirth" [placeholder]="'MM_DD_YYYY' | translate"
                            [required]="fieldRequired('dateOfBirth')" [ngModel]="member.dateOfBirth" [min]="minDate" [max]="maxDate" #dateOfBirthInput
                            #memberDateOfBirth="ngModel"
                            (click)="globalService.OpenCalendar(dateOfBirth)" />
                          <mat-datepicker [touchUi]="
                              (globalService.isHandset$ | async)
                                ? 'true'
                                : 'false'
                            " #dateOfBirth></mat-datepicker>
                          <div class="input-group-append">
                            <button type="button" class="btn btn-secondary btn-small input-group-text"
                              [disabled]="member.hasAccount" [attr.aria-label]="'DOB' | translate"
                              (click)="globalService.OpenCalendar(dateOfBirth)">
                              <span>
                                <i class="fas fa-calendar-alt"></i>
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>
                      <small class="help-block" *ngIf="fieldRequired('dateOfBirth') && ((dateOfBirthInput.value == null || dateOfBirthInput.value.trim() == '') && (dateOfBirthInput.touched || submitMember))
                      && (indexOfMember == curIndex)">{{
                        globalService.Get("DOB_REQUIRED") }}</small>
                    </div>
                    <div class="form-group col-12 col-md-6" [class.text-right]="globalService.isRTL == true"
                      *ngIf="shortDate == true && !fieldHidden('dateOfBirth')">
                      <label for="dateOfBirth">{{
                        globalService.Get("DOB")
                        }} <span *ngIf="fieldRequired('dateOfBirth')" class="required-marker" [attr.aria-label]="'REQUIRED' | translate">*</span></label>
                      <div>
                        <div class="input-group">
                          <input class="form-control" [disabled]="member.hasAccount || shortDate == true"
                            [value]="GetMemberShortDate(member.dateOfBirth)" />
                        </div>
                      </div>
                    </div>
                    <div [hidden]="fieldHidden('gender')" class="form-group col-12 col-md-6">
                      <label class="mr-3" for="gender">{{
                        globalService.Get("GENDER")
                        }} <span *ngIf="fieldRequired('gender')" class="required-marker" [attr.aria-label]="'REQUIRED' | translate">*</span></label>
                      <select id="gender" class="form-control" [class.classicRTL]="globalService.isRTL == true"
                        [class.classic]="globalService.isRTL == false" name="gender" [disabled]="member.hasAccount"
                         #gender="ngModel" [(ngModel)]="member.gender" [required]="fieldRequired('gender')">
                        <option [ngValue]="null" [disabled]="fieldRequired('gender')">
                          {{ globalService.Get("SELECT") }}
                        </option>
                        <option [ngValue]="false">
                          {{ globalService.Get("MALE") }}
                        </option>
                        <option [ngValue]="true">
                          {{ globalService.Get("FEMALE") }}
                        </option>
                      </select>
                      <small class="help-block"
                        *ngIf="!gender.valid && (gender.touched || submitMember)  && (indexOfMember == curIndex)">{{
                        globalService.Get("GENDER_REQUIRED") }}</small>
                    </div>
                    <div class="form-group col-12 col-md-6">
                      <label class="mr-3" for="relationship">{{
                        globalService.Get("RELATIONSHIP")
                        }} <span class="required-marker" [attr.aria-label]="'REQUIRED' | translate">*</span></label>
                      <select id="relationship" class="form-control" [class.classicRTL]="globalService.isRTL == true"
                        [class.classic]="globalService.isRTL == false" name="relationship" #relationship="ngModel"
                        [disabled]="member.hasAccount" [(ngModel)]="member.relationship" required>
                        <option [ngValue]="null">
                          {{ globalService.Get("SELECT") }}
                        </option>
                        <option [ngValue]="1">
                          {{ globalService.Get("SPOUSE") }}
                        </option>
                        <option [ngValue]="2">
                          {{ globalService.Get("CHILD") }}
                        </option>
                        <option [ngValue]="4">
                          {{ globalService.Get("SIBLING") }}
                        </option>
                        <option [ngValue]="5">
                          {{ globalService.Get("PARENT") }}
                        </option>
                        <option [ngValue]="6">
                          {{ globalService.Get("RELATIVE") }}
                        </option>
                        <option [ngValue]="3">
                          {{ globalService.Get("OTHER") }}
                        </option>
                      </select>
                      <small class="help-block"
                        *ngIf="!relationship.valid && (relationship.touched || submitMember)  && (indexOfMember == curIndex)">{{
                        globalService.Get("RELATIONSHIP_REQUIRED") }}</small>
                    </div>
                    <div class="form-group col-12 col-md-6">
                      <label class="mr-3" for="churchMember">{{ globalService.Get("MEMBERSHIP") }}
                      </label>
                      <select id="isMember" class="form-control" [class.classicRTL]="globalService.isRTL == true"
                        [class.classic]="globalService.isRTL == false" name="isMember" [disabled]="member.hasAccount"
                        #isMember="ngModel" [(ngModel)]="member.isMember" required>
                        <!-- <option [ngValue]="null">Select</option> -->
                        <option [ngValue]="true">
                          {{ globalService.Get("MEMBER") }}
                        </option>
                        <option [ngValue]="false">
                          {{ globalService.Get("GUEST") }}
                        </option>
                      </select>
                      <div class="input-group mt-2" *ngIf="
                          indexOfMember > 0 &&
                          member.requestDescription != '' &&
                          workflow == true
                        ">
                        <div [class.input-group-prepend]="adminAccess == true" *ngIf="adminAccess == false">
                          <span class="input-group-text" id="basic-addon1">
                            {{
                            globalService.Get(
                            member.requestDescription.split(" ")[0]
                            )
                            }}
                          </span>
                        </div>
                        <div [class.input-group-prepend]="adminAccess == true" *ngIf="adminAccess == true">
                          <span class="input-group-text" id="basic-addon1">
                            {{
                            globalService.Get(
                            member.requestDescription.split(" ")[0]
                            ) +
                            " " +
                            globalService.Get(
                            member.requestDescription
                            .split(" ")[1]
                            .trim()
                            .toUpperCase()
                            ) +
                            " " +
                            member.requestDescription.split(" ")[2]
                            }}
                          </span>
                        </div>
                        <div class="input-group-append" *ngIf="adminAccess == true">
                          <button type="button" class="btn btn-success btn-small"
                            (click)="AcceptRequest(member.id, indexOfMember)">
                            <span>
                              <i class="fas fa-check-circle mr-1"></i><small>{{ globalService.Get("APPROVE") }}</small>
                            </span>
                          </button>
                        </div>
                        <div class="input-group-append" *ngIf="adminAccess == true">
                          <button type="button" class="btn btn-danger btn-small"
                            (click)="DenyRequest(member.id, indexOfMember)">
                            <span>
                              <i class="fas fa-times-circle mr-1"></i><small>{{
                                globalService.Get("DENY")
                                }}</small></span>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div [hidden]="fieldHidden('maritalStatus')" class="form-group col-12 col-md-6" [class.text-right]="globalService.isRTL == true">
                      <label for="maritalStatus">{{
                        globalService.Get("MARITAL_STATUS")
                        }} <span *ngIf="fieldRequired('maritalStatus')" class="required-marker" [attr.aria-label]="'REQUIRED' | translate">*</span></label>
                      <select id="maritalStatus" class="form-control" [class.classicRTL]="globalService.isRTL == true"
                        [class.classic]="globalService.isRTL == false" name="maritalStatus"
                        [disabled]="member.hasAccount" #maritalStatus="ngModel" [(ngModel)]="member.maritalStatus" [required]="fieldRequired('maritalStatus')">
                        <option [ngValue]="null">
                          {{ globalService.Get("SELECT") }}
                        </option>
                        <option [ngValue]="0">
                          {{ globalService.Get("SINGLE") }}
                        </option>
                        <option [ngValue]="1">
                          {{ globalService.Get("ENGAGED") }}
                        </option>
                        <option [ngValue]="2">
                          {{ globalService.Get("MARRIED") }}
                        </option>
                        <option [ngValue]="3">
                          {{ globalService.Get("WIDOWED") }}
                        </option>
                        <option [ngValue]="4">
                          {{ globalService.Get("DIVORCED") }}
                        </option>
                        <option [ngValue]="5">
                          {{ globalService.Get("DEPARTED") }}
                        </option>
                      </select>
                      <small class="help-block"
                        *ngIf="!maritalStatus.valid && (maritalStatus.touched || submitMember)  && (indexOfMember == curIndex)">{{
                        globalService.Get("MARITAL_STATUS_REQUIRED") }}</small>
                    </div>
                    <div [hidden]="fieldHidden('email')" class="form-group col-12 col-md-6">
                      <label for="emailAddress">{{
                        globalService.Get("EMAIL")
                        }} <span *ngIf="fieldRequired('email')" class="required-marker" [attr.aria-label]="'REQUIRED' | translate">*</span></label>
                      <input type="text" id="emailAddress" class="form-control" name="emailAddress"
                        [disabled]="member.hasAccount" #emailAddress="ngModel" [(ngModel)]="member.emailAddress"
                        autocomplete="off" [required]="fieldRequired('email')" />
                    </div>
                    <div class="form-group col-12 col-md-6">
                      <label for="phoneNumber">{{
                        globalService.Get("CELLPHONE")
                        }}</label>
                      <input type="text" id="phoneNumber" class="form-control" [disabled]="member.hasAccount"
                        name="phoneNumber" #phoneNumber="ngModel" [(ngModel)]="member.phoneNumber" autocomplete="off" />
                    </div>
                    <div [hidden]="fieldHidden('occupation')" class="form-group col-12" [class.text-right]="globalService.isRTL == true">
                      <label for="occupation">{{ globalService.Get("OCCUPATION") }} <span *ngIf="fieldRequired('occupation')" class="required-marker" [attr.aria-label]="'REQUIRED' | translate">*</span></label>
                      <div>
                        <select id="occupation" class="form-control" [class.classicRTL]="globalService.isRTL == true"
                          [class.classic]="globalService.isRTL == false" name="occupation" #occupation="ngModel"
                          [(ngModel)]="member.occupation" [disabled]="member.hasAccount" [required]="fieldRequired('occupation')">
                          <option [ngValue]="null">
                            {{ globalService.Get("SELECT") }}
                          </option>
                          <option *ngFor="let occupation of occupations" [ngValue]="occupation.id">
                            {{ occupation.name }}
                          </option>
                        </select>

                      </div>
                    </div>
                    <div *ngFor="let extension of member.extensionValues; let i = index"
                      class="form-group col-12 col-md-6">
                      <div *ngIf="extension['optionsList'] != null">
                        <label>{{ extension.label }} <span *ngIf="extension.mandatory" class="required-marker" [attr.aria-label]="'REQUIRED' | translate">*</span></label>
                        <select [attr.name]="'Ext-' + extension.key" class="form-control"
                          [class.classicRTL]="globalService.isRTL == true" [(ngModel)]="extension['value']"
                          (ngModelChange)="extensionChange(memberForm, member)" [ngModelOptions]="{standalone: true}"
                          [class.classic]="globalService.isRTL == false" [disabled]="member.hasAccount"
                          [required]="extension['mandatory'] == true" #memberExtension="ngModel">
                          <option [ngValue]="null">{{ globalService.Get("SELECT") }}</option>
                          <option *ngFor="let option of extension['optionsList']" [ngValue]="option">
                            {{ option }}
                          </option>
                        </select>
                        <small class="help-block"
                          *ngIf="(!memberExtension.valid || memberExtension == null) && (memberExtension.touched || submitMember)  && (indexOfMember == curIndex)">
                          {{ 'VALUE0_REQUIRED' | translate:{value0:(extension.label)} }}</small>
                      </div>
                      <div *ngIf="extension['optionsList'] == null">
                        <label>{{ extension.label }} <span *ngIf="extension.mandatory" class="required-marker" [attr.aria-label]="'REQUIRED' | translate">*</span></label>
                        <input [attr.name]="'Ext-' + extension.key" type="text" class="form-control"
                          [(ngModel)]="extension['value']" #memberExtension="ngModel" [disabled]="member.hasAccount"
                          (ngModelChange)="extensionChange(memberForm, member)" [ngModelOptions]="{standalone: true}"
                          [required]="extension['mandatory'] == true" />
                        <small class="help-block"
                          *ngIf="(!memberExtension.valid || memberExtension == null) && (memberExtension.touched || submitMember)  && (indexOfMember == curIndex)">
                          {{ 'VALUE0_REQUIRED' | translate:{value0:(extension.label)} }}</small>
                      </div>
                    </div>
<div class="form-group col-12"><label class="communication-switch" for="receive-Text{{ indexOfMember }}"><span>{{ 'RECEIVE_TEXT_MESSAGES' | translate }}</span><input id="receive-Text{{ indexOfMember }}" type="checkbox" role="switch" [ngModel]="!member.disableText" (ngModelChange)="setMemberCommunication(member, 'disableText', $event)" name="receiveText" [disabled]="member.hasAccount || memberSaving" /><span class="switch-track" aria-hidden="true"></span></label></div>
<div class="form-group col-12"><label class="communication-switch" for="receive-Email{{ indexOfMember }}"><span>{{ 'RECEIVE_EMAILS' | translate }}</span><input id="receive-Email{{ indexOfMember }}" type="checkbox" role="switch" [ngModel]="!member.disableEmail" (ngModelChange)="setMemberCommunication(member, 'disableEmail', $event)" name="receiveEmail" [disabled]="member.hasAccount || memberSaving" /><span class="switch-track" aria-hidden="true"></span></label></div>
                    <div class="px-4" *ngIf="member.hasAccount == true">
                      <small>
                        {{ globalService.Get("ACCOUNT_HOLDER_EDIT") }}
                      </small>
                    </div>
                    <div *ngIf="isAdmin == 'true'" class="text-right" style="width: 100%;">
                      <small *ngIf="member.createdBy != null && member.createdBy != ''" style="width: 100%;"> <input
                          type="text" id="createdBy" class="form-control" disabled="true" style="width: 100%;"
                          name="createdBy" [ngModel]="member.createdBy" autocomplete="off" /></small>
                      <small style="width: 100%;"> <input type="text" id="creationDate" class="form-control"
                          disabled="true" style="width: 100%;" name="creationDate"
                          [ngModel]="member.creationDate | localizedDate: 'MM/dd/yyyy'" autocomplete="off" /></small>
                    </div>

                    <div class="text-right col-12"
                      *ngIf="(isMemberSuccess == true || confirmDelete || memberError) && indexOfMember == curIndex">
                      <app-prompt-message [showForm]="isMemberSuccess == true && indexOfMember == curIndex"
                        (onClose)="isMemberSuccess = false" color="success"
                        [message]="globalService.Get(memberMessage)">
                      </app-prompt-message>

                      <app-confirm-message [showForm]="confirmDelete && indexOfMember == curIndex" color="danger"
                        (onConfirm)="OnDeleteMember(indexOfMember, member.id)" (onCancel)="confirmDelete = false"
                        [message]="'DELETE_HOUSEHOLD_MEMBER' | translate" [detail]="'UI_THIS_REMOVES_THIS_MEMBER_FROM_YOUR_HOUSEHOLD' | translate" [confirmLabel]="'UI_DELETE_MEMBER' | translate">
                      </app-confirm-message>

                      <app-prompt-message [showForm]="memberError && indexOfMember == curIndex"
                        (onClose)="memberError = ''" color="danger" [message]="globalService.Get(memberError)">
                      </app-prompt-message>
                    </div>

                    <div class="text-center col-12"
                      *ngIf="!memberForm.valid && (memberForm.touched || submitMember)  && (indexOfMember == curIndex)">
                      <div class="alert alert-danger" role="alert">
                        <small>{{ 'CHECK_REQUIRED_FIELDS' | translate }}</small>
                      </div>
                    </div>

                    <div class="col-12 household-edit-actions" *ngIf="!member.isPrimary && allowEdit"><div *ngIf="(!member.isPrimary && allowEdit == true)">
                      <!-- <label fxShow.gt-md="false"> </label> -->
                      <button class="btn btn-primary btn-block" type="submit" [disabled]="!memberForm.dirty || memberSaving || memberDeleting">
                        <div *ngIf="!memberSaving || indexOfMember != curIndex">
                          <span>
                            <i class="fas fa-save"></i>
                            {{ globalService.Get("SAVE") }}
                          </span>
                        </div>
                        <div *ngIf="memberSaving && indexOfMember == curIndex">
                          <span>
                            <i class="fas fa-spinner fa-spin"></i>
                            {{ globalService.Get("SAVE") }}
                          </span>
                        </div>
                      </button>
                    </div><div *ngIf="(!member.isPrimary) && (allowEdit == true)">
                      <!-- <label fxShow.gt-md="false"> </label> -->
                      <button class="btn btn-outline-danger btn-block" type="button" [disabled]="memberSaving || memberDeleting" (click)="showConfirm(indexOfMember)">
                        <div *ngIf="memberDeleting && indexOfMember == curIndex">
                          <span>
                            <i class="fas fa-spinner fa-spin"></i>
                            {{ globalService.Get("DELETE") }}
                          </span>
                        </div>
                        <div *ngIf="!memberDeleting || indexOfMember != curIndex">
                          <span>
                            <i class="fas fa-user-minus"></i>
                            {{ globalService.Get("DELETE") }}
                          </span>
                        </div>
                      </button>
                    </div></div>
                  </div>
                </div>
                <div [hidden]="fieldHidden('picture')" class="order-1 order-lg-2 mt-3 mt-lg-2 mt-xl-0" [class.col-12]="member.isPrimary == false"
                  [class.col-lg-3]="member.isPrimary == false" *ngIf="member.isPrimary == false">

                  <div class="form-group text-center">

                    <!-- Image -->
                    <div *ngIf="member.pictureUrl">
                      <a [href]="member.pictureUrl" target="_blank" rel="noopener noreferrer">

                        <img [src]="member.pictureUrl" class="profileImage mb-2 d-block mx-auto"
                          style="cursor: pointer;" />

                      </a>
                    </div>

                    <!-- Buttons -->
                    <div class="d-flex justify-content-center gap-2 mt-2" *ngIf="allowEdit == true">

                      <label for="memberPic{{ indexOfMember }}" class="btn btn-primary btn-small"
                        [class.disabled]="member.hasAccount">
                        {{ globalService.Get("SELECT") }}
                      </label>

                      <label class="btn btn-danger btn-small" (click)="resetPicture(indexOfMember, memberForm)"
                        [class.disabled]="member.hasAccount">
                        {{ globalService.Get("CLEAR") }}
                      </label>

                    </div>

                    <small *ngIf="householdEditor" class="d-block text-muted mt-2">{{ 'PHOTO_CHANGES_ARE_SAVED_WHEN_YOU_TAP_SAVE' | translate }}</small>
                    <!-- Input -->
                    <input hidden type="file" accept="image/*" id="memberPic{{ indexOfMember }}"
                      name="memberPic{{ indexOfMember }}" (change)="onFileSelectedPrimary($event, indexOfMember, memberForm)" />

                  </div>
                </div>
              </div>
              <div class="form-group alert alert-primary recommendationAlert" role="alert" *ngIf="
                  recommendationId > 0 &&
                  recommendationClosed == false &&
                  indexOfMember == curIndex
                ">
                <div class="row">
                  <div class="col-12">
                    {{ recommendationMessage }}
                  </div>
                </div>
                <div class="mt-3" *ngFor="let candidate of householdCandidates">
                  <p>{{ candidate.firstName }} {{ candidate.lastName }} &mdash; {{ candidate.dateOfBirth ? (candidate.dateOfBirth | localizedDate:'mediumDate') : ('DATE_OF_BIRTH_NOT_PROVIDED' | translate) }}</p>
                  <button class="btn btn-primary" type="button" [disabled]="memberSaving" (click)="YesRecommendation(candidate.id)">{{ 'SAME_PERSON_USE_THIS_RECORD' | translate }}</button>
                </div>
                <div class="mt-3 d-flex flex-wrap" style="gap:.5rem">
                  <button class="btn btn-outline-primary" type="button" [disabled]="memberSaving" (click)="NoRecommendation()">{{ 'DIFFERENT_PEOPLE_CREATE_A_NEW_RECORD' | translate }}</button>
                  <button class="btn btn-outline-secondary" type="button" [disabled]="memberSaving" (click)="LaterRecommendation()">{{ 'CREATE_NOW_REVIEW_LATER' | translate }}</button>
                </div>
              </div>
              <button *ngIf="householdEditor && !member.isPrimary" class="btn btn-outline-secondary btn-block mb-3" type="button" [disabled]="memberSaving || changingHouseholdEdit" [attr.aria-busy]="changingHouseholdEdit" (click)="requestCancelHouseholdEdit(memberForm)"><i *ngIf="changingHouseholdEdit" class="fas fa-spinner fa-spin profile-edit-spinner" aria-hidden="true"></i>{{ 'CANCEL_EDITING' | translate }}</button>
              <ng-container *ngIf="householdEditor && !member.isPrimary && (member.id === 0 || editingHouseholdMemberId === member.id) && !continueAfterDiscard"><ng-container *ngTemplateOutlet="discardEditPrompt"></ng-container></ng-container>
            </form>
          </div>
          <div id="members"></div>
          <div class="form-group row" *ngIf="allowEdit == true && (!householdEditor || (!editingPrimary && editingHouseholdMemberId === null && !newMemberNotSaved && !changingHouseholdEdit))" [class.SmallArabicFont]="globalService.isRTL == true">
            <div class="col-12">
              <div class="text-center">
                <app-prompt-message [showForm]="subscriptionError == true" color="danger"
                  (onClose)="subscriptionError = false"
                  [message]="'SUBSCRIPTION_LIMIT_HAS_BEEN_REACHED_PLEASE_CONTACT_THE_CHURCH_ADMIN' | translate">
                </app-prompt-message>
                <button class="btn btn btn-primary btn-block" type="button" [disabled]="householdEditor && (changingHouseholdEdit || memberSaving || profileSaving || newMemberNotSaved || editingPrimary || editingHouseholdMemberId !== null)" (click)="OnAddNewMember()">
                  <span> <i class="fas fa-spinner fa-spin" *ngIf="addingHouseholdMember == true"></i>
                    <i class="fas fa-user-plus" *ngIf="addingHouseholdMember == false"></i>
                    {{ globalService.Get("ADD_HOUSEHOLD_MEMBER") }}
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="householdEditor" class="mt-3 text-center">
          <button type="button" class="btn btn-primary btn-block" [disabled]="memberSaving || profileSaving || changingHouseholdEdit || continuingToApp" (click)="finishHouseholdSetup()"><i *ngIf="continuingToApp" class="fas fa-spinner fa-spin mr-2" aria-hidden="true"></i>{{ householdSetup ? ('CONTINUE_TO_APP' | translate) : ('DONE' | translate) }}</button>
          <ng-container *ngIf="continueAfterDiscard"><ng-container *ngTemplateOutlet="discardEditPrompt"></ng-container></ng-container>
          <small class="d-block mt-3">{{ isAdmin === 'true' ? ('YOU_CAN_MANAGE_THIS_ACCOUNT_AND_ITS_HOUSEHOLD_MEMBERS_HERE' | translate) : ('YOU_CAN_UPDATE_YOUR_HOUSEHOLD_ANYTIME_IN_MY_PROFILE' | translate) }}</small>
        </div>
        <ng-content></ng-content>
      </div>
    </div>
  </div>

<ng-template #discardEditPrompt>
  <app-confirm-message [showForm]="confirmDiscardEdit" [busy]="changingHouseholdEdit" color="danger" [message]="'DISCARD_YOUR_CHANGES' | translate" [detail]="'UI_UNSAVED_INFORMATION_AND_PHOTO_CHANGES_WILL_BE_LOST' | translate" [confirmLabel]="'UI_DISCARD_CHANGES' | translate" [cancelLabel]="'CMS_KEEP_EDITING' | translate" (onConfirm)="cancelHouseholdEdit()" (onCancel)="keepEditing()"></app-confirm-message>
</ng-template>
